import React from 'react'
import { Box, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import { Field, ErrorMessage } from 'formik'

const InviteStaffForm = ({ formikProps, departmentList }) => {
  const { handleChange, values, touched, errors } = formikProps

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 2,
        px: 0.5,
      }}
    >
      <Typography variant="body1" color="light-gray-text.main">
        Invite your staff individually by filling in the details below
      </Typography>
      <Box sx={{ width: 1 }}>
        <Field
          as={AdxInput}
          label={`Full Name`}
          name="name"
          value={values.name}
          onChange={handleChange}
          type="text"
          errorMessage={
            touched.name && errors.name && <ErrorMessage name="name" component={AdxErrorMessage} />
          }
          isErrorShown={touched.name && errors.name}
        />
      </Box>
      <Box sx={{ width: 1 }}>
        <Field
          as={AdxInput}
          label={`Work Email (Invitation will be sent to this email)`}
          name="email"
          value={values.email}
          onChange={handleChange}
          placeholder="E.g: example@gmail.com"
          errorMessage={
            touched.email &&
            errors.email && <ErrorMessage name="email" component={AdxErrorMessage} />
          }
          isErrorShown={touched.email && errors.email}
        />
      </Box>
      <Box sx={{ width: 1 }}>
        <Field
          as={AdxInput}
          label={`Job Designation`}
          name="designation"
          value={values.designation}
          onChange={handleChange}
          placeholder="E.g: UI/UX Designer"
          errorMessage={
            touched.designation &&
            errors.designation && <ErrorMessage name="designation" component={AdxErrorMessage} />
          }
          isErrorShown={touched.designation && errors.designation}
          charLimit={50}
        />
      </Box>
      <Box sx={{ width: 1 }}>
        <Field
          as={AdxDropdown}
          label={`Department`}
          name="department_id"
          value={values.department_id}
          onChange={handleChange}
          errorMessage={
            touched.department_id &&
            errors.department_id && (
              <ErrorMessage name="department_id" component={AdxErrorMessage} />
            )
          }
          isErrorShown={touched.department_id && errors.department_id}
        >
          {departmentList &&
            departmentList?.map((option) => (
              <AdxMenuItem value={option.id} selectedvalue={values.department_id}>
                {option.name}
              </AdxMenuItem>
            ))}
        </Field>
      </Box>
    </Box>
  )
}

export default InviteStaffForm
